module.exports = __webpack_public_path__ + "media/images/PromotionalIcon-01-afe29f8b.png";